import axios from "axios";
import { useState, useEffect } from "react";
import { format } from "date-fns";
const Disapproved = ({ id }) => {
  const [disApprovedLeave, setDisApprovedLeave] = useState("");
  const [singleDisApprovedLeave, setSingleDisApprovedLeave] = useState("");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const getDisApprovedApplications = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/leave/detailsByLeaveID/${id}`
      );
      // console.log(response.data.leaves || []);
      setDisApprovedLeave(response.data.leaves);
    } catch (error) {
      console.log([]);
    }
  };
  const getSingleDisApprovedApplications = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/employee/${disApprovedLeave.EmployeeID}`
      );
      console.log(response.data.employeeInfo);
      setSingleDisApprovedLeave(response.data.employeeInfo);
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(disApprovedLeave.Total);
  useEffect(() => {
    getSingleDisApprovedApplications();
    getDisApprovedApplications();
  }, [disApprovedLeave.EmployeeID, id]);

  return (
    <div className="flex p-5 flex-col flex-wrap lg:flex-row gap-6 md:divide-x md:divide-gray-200">
      {/*FIRST-SECTION APPLICATION*/}

      <div className="flex-1 px-4">
        {/* Content for the first section */}
        <h2 className="text-base font-semibold mb-4 text-gray-800">Application Details</h2>

        <div className="space-y-3">
          <p className="text-sm">
            <span className="font-medium text-gray-700">Name:</span> <span className="text-gray-900">{disApprovedLeave.Name}</span>
          </p>

          <p className="text-sm">
            <span className="font-medium text-gray-700">Applied Date:</span> <span className="text-gray-900">{disApprovedLeave.DateApplied}</span>
          </p>

          <div>
            <p className="text-sm font-medium text-gray-700 mb-1">Leave Dates:</p>
            {disApprovedLeave.Date ? (
              <ul className="text-sm text-gray-900 ml-4 space-y-1">
                {JSON.parse(disApprovedLeave.Date).map((date, index) => (
                  <li key={index} className="list-disc">{format(new Date(date), "yyyy-MM-dd")}</li>
                ))}
              </ul>
            ) : (
              <span className="text-sm text-gray-500">No leave dates available.</span>
            )}
          </div>

          <p className="text-sm"><span className="font-medium text-gray-700">Cause:</span> <span className="text-gray-900">{disApprovedLeave.Cause}</span></p>

          <p className="text-sm">
            <span className="font-medium text-gray-700">Leave Type:</span> <span className="text-gray-900">{disApprovedLeave.Type}</span>
          </p>

          <p className="text-sm">
            <span className="font-medium text-gray-700">Address:</span> <span className="text-gray-900">{disApprovedLeave.Address}</span>
          </p>

          <p className="text-sm">
            <span className="font-medium text-gray-700">Contact:</span> <span className="text-gray-900">{disApprovedLeave.Contact}</span>
          </p>
        </div>
      </div>

      {/* SECOND-SECTION LEAVE STATUS */}

      <div className="flex-1 px-4">
        {/* Content for the second section */}
        <h2 className="text-base font-semibold mb-4 text-gray-800">Leave Status</h2>

        <table className="min-w-full text-sm border border-gray-200 rounded-lg">
          <thead className="border-b bg-gray-50">
            <tr>
              <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Total</th>
              <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Applied</th>
              <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Due</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center border-b">
              <td className="px-4 py-2.5 bg-blue-50 font-medium">
                16
              </td>
              <td className="px-4 py-2.5 bg-red-50 font-medium">
                {disApprovedLeave.Total}
              </td>
              <td className="px-4 py-2.5 bg-green-50 font-medium">
                {singleDisApprovedLeave.SickLeaveLeft +
                  singleDisApprovedLeave.CasualLeaveLeft}
              </td>
            </tr>
          </tbody>
        </table>

        <p className="text-sm text-gray-800 mt-3 font-medium">
          Current Request: {disApprovedLeave.Total} days
        </p>
      </div>

      {/* THIRD SECTION GIVE APPROVAL */}
      <div className="flex-1 px-4">
        <h2 className="text-base font-semibold mb-4 text-gray-800">Status</h2>

        <div className="flex items-center text-sm space-x-2 text-red-700 bg-red-50 p-4 rounded-lg border border-red-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          <span className="font-semibold">Disapproved</span>
        </div>
      </div>
    </div>
  );
};

export default Disapproved;
